<template>
  <div class="tablePage">
    <el-table
      v-loading="loading"
      stripe
      ref="multipleTable"
      :data="tableData"
      tooltip-effect="dark"
      style="width: 100%"
      :header-cell-style="headCellStyle"
      :height="tableHeight"
      @selection-change="handleSelectionChange"
    >
      <el-table-column type="selection" width="50" />
      <el-table-column
        prop="scopeName"
        :label="$t('public.table_scope')"
        show-overflow-tooltip
      />
      <el-table-column
        prop="tagId"
        :label="$t('integration.number')"
        show-overflow-tooltip
      >
        <template #default="{ row }">
          <span>
            <i v-icon:theme="['sensorTypeConvert', row.type]"></i>
            <!-- <i v-icon:theme="['equiStatusConvert', row.status]"></i> -->
            <!-- <i :class="sensorTypeConvert(row.type).icon" style="margin-right:5px;cursor: pointer;"
                          :title="$t(sensorTypeConvert(row.type).title)"></i>
                      <i :class="equiStatusConvert(row.status).icon" style="margin-right:5px;cursor: pointer;font-size:18px"
                          :title="$t(equiStatusConvert(row.status).title)"></i> -->
            <el-popover placement="top-start" width="auto" trigger="hover">
              <v-popoer :rowData="row" :typeWay="typeWay" />
              <span slot="reference">{{ row.tagId }}</span>
            </el-popover>
          </span>
        </template>
      </el-table-column>

      <!-- 创建时间只存在于未确认 -->
      <el-table-column
        prop="createTime"
        :label="$t('public.table_create_time')"
        show-overflow-tooltip
      >
        <template #default="{ row }">
          <span>{{ $timetransition(row.createTime) }}</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="description"
        :label="$t('public.table_desc')"
        show-overflow-tooltip
      />
      <el-table-column
        prop="optare"
        fixed="right"
        :label="$t('public.table_operation')"
        width="160"
        align="center"
      >
        <template #default="{ row }">
          <el-button
            type="text"
            size="small"
            v-for="item in optareBtn"
            :key="item.id"
            :title="$t(item.title)"
            :icon="item.icon"
            @click="handle(item.method, row)"
          ></el-button>
          <!-- v-has="item.vHas" -->
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
import dialog from './Diolag.vue'
import popover from '../../Popover.vue'
import { equiStatusConvert } from '@/utils/convert'
import { getIsSys } from '@/utils/permission'
import { sensorTypeConvert } from '@/utils/dict/sensor'

export default {
  name: 'Table',
  components: {
    'v-popoer': popover,
    'v-dialog': dialog
  },
  props: ['loading', 'tableData'],

  computed: {
    i18n () {
      return this.$i18n.locale
    },
    isSys () {
      return getIsSys()
    }
  },
  data () {
    return {
      sensorTypeConvert,
      equiStatusConvert,
      tableHeight: '100%',
      optareBtn: [
        {
          id: 1,
          title: $t('public.edit'),
          icon: 'el-icon-edit-outline',
          vHas: [],
          method: 'editFn'
        },
        {
          id: 4,
          title: 'public.details',
          icon: 'el-icon-tickets',
          vHas: [],
          method: 'detailFn'
        },
        {
          id: 3,
          title: $t('public.tbopt_delete'),
          icon: 'el-icon-delete',
          vHas: [],
          method: 'delRowFn'
        },
      ],
      // 默认为绑定状态
      typeWay: 'unknow'
    }
  },
  methods: {
    handleSelectionChange (arg) {
      this.$emit('choozeTable', arg)
    },
    handle (method, row) {
      this.$emit(method, row)
    },
    // 校准图标hover字样内容
    contentFn(row){
      if(row.calibrationType === 1){
        return this.$t('device.calibration_expiration') + ':' + this.$timetransition(row.calibrationExpireTime, 'Y-M-D')
      }
      if(row.calibrationType === 0){
        return $t('device.no_calibration')
      }
      return $t('device.no_set_calibration')

    }
  }
}
</script>

<style lang="scss" scoped>
.tablePage {
  height: calc(100% - 60px);
}
</style>
